import { IResendEmail } from "../interfaces/common";
import {
  POST,
  SUCCESS,
  ERROR,
  DISABLED_RESEND_EMAIL_TIMEOUT,
  SUCCESS_ALERT_DURATION,
} from "./constants";
import { fetchData } from "./dataProvider";
import { IAlert } from "../interfaces/alert";
import { IFooter } from "../interfaces/order";
import { parseLineBreaksForHTML } from "./text";

interface IInsertTemplateParams {
  html: string;
  banner?: string;
  logo?: string;
  description?: string;
  footer?: IFooter;
}

const replaceTemplateCode = (
  template: string,
  codeToReplace: string,
  infoToInsert: string,
) => template.replaceAll(codeToReplace, infoToInsert);

export const generateFooterHtml = (footer: IFooter): string => {
  if (!footer.enabled || !footer.content) return "";

  return `
    <tr>
      <td style="padding: 20px 24px; border-top: 1px solid #eee; font-family: 'Lato', sans-serif; color: #333;">
        ${footer.content}
      </td>
    </tr>
  `;
};

export const insertLocalImagesOnHtml = ({
  html,
  banner,
  logo,
  description = "",
  footer,
}: IInsertTemplateParams): string => {
  let parsed = replaceTemplateCode(
    html,
    "$DESCRIPTION$",
    parseLineBreaksForHTML(description),
  );
  if (banner) parsed = replaceTemplateCode(parsed, "$BANNER_SRC$", banner);
  if (logo) parsed = replaceTemplateCode(parsed, "$LOGO_SRC$", logo);

  if (footer && footer.enabled) {
    const footerHtml = generateFooterHtml(footer);
    parsed = parsed.replace("</table>", `${footerHtml}</table>`);
  }

  return parsed;
};

export const reSendEmail = ({
  email,
  setAlert,
  confirmationMessage,
}: IResendEmail) => {
  try {
    fetchData({
      url: "/users/forwardEmail",
      method: POST,
      body: { email },
    });
    setAlert({
      typeOfAlert: SUCCESS,
      message:
        confirmationMessage || "El correo electrónico se ha enviado con éxito.",
      showAlert: true,
    });
  } catch (error: any) {
    setAlert({
      typeOfAlert: ERROR,
      message: error,
      showAlert: true,
    });
  }
};

export const setDisabledFalse = (setDisabled: (disabled: boolean) => void) =>
  setTimeout(() => setDisabled(false), DISABLED_RESEND_EMAIL_TIMEOUT);

export const handleResendEmail = (
  setDisabled: (disabled: boolean) => void,
  email: string,
  setAlert: (alert: IAlert) => void,
) => {
  setDisabled(true);
  reSendEmail({ email, setAlert });
  setTimeout(() => setAlert({} as IAlert), SUCCESS_ALERT_DURATION);
  setDisabledFalse(setDisabled);
};
